import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What programs does Storm Taekwondo offer?',
  answer: 'Storm offers Mini Troopers, kids taekwondo, adult classes, family classes, self-defense, competition team training, and seasonal summer camp.'
}, {
  question: 'What age can kids start?',
  answer: 'Storm has programs for ages 3 and up, including Mini Troopers for younger children.'
}, {
  question: 'Is this good for beginners?',
  answer: 'Yes. No experience is needed to start. Storm helps new students learn step by step.'
}, {
  question: 'Do parents need to buy gear before starting?',
  answer: 'No. New students can start with a trial class before buying gear.'
}, {
  question: 'Is this karate or taekwondo?',
  answer: "Storm teaches taekwondo. Many parents search for kids karate when looking for martial arts, but Storm's program is taekwondo-based."
}, {
  question: 'Do you offer adult and family classes?',
  answer: 'Yes. Storm offers adult classes and family classes along with kids programs.'
}, {
  question: 'Do you offer summer camp?',
  answer: 'Yes. Storm offers seasonal summer camp. Use the form or call 517-220-0621 to ask about availability.'
}, {
  question: 'What is the difference between a class and a program?',
  answer: 'A class is the individual training session a student attends. A program is the larger path they join, such as Mini Troopers, Kids Taekwondo, Adult Taekwondo, Family Classes, Self-Defense, Competition Team, or Summer Camp.'
}];
export function HomeFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-1663" />;
}